import { DateObject } from '@capsicum/common';

/**
 * util to add 3 second at the published time, to avoid call lobby endpoint before backend reconcile process finish
 * SHARED BETWEEN MOB AND WEB
 *
 * @param {startDate} startDate date sent by fto search endpoint
 *
 * @returns {DateObject} a new DateObject with start date + 3 seconds
 */
export const delayedStartDate = (startDate: string) => {
	const originalDate = new DateObject(startDate);

	return new DateObject(originalDate.add(3, 'seconds'));
};
